import React, { memo, useEffect, useState } from "react";
import useSWRInfinite                       from "swr/infinite";

import { formatReel }          from "_common/utils/broadcast";
import { getFormattedData }    from "_common/utils/results";
import ErrorPage               from "_components/atoms/emptyView";
import { getSearchTabResults } from "_services/api/feed";

import Presentation from "./presentation";

export const getResults = async function ( params ) {
	const { searchQuery, key } = params;
	const response             = await getSearchTabResults.bind ( this ) ( params, searchQuery );

	if ( key === "all" ) {
		if ( !key || !searchQuery ) return [];
		const { mergedVideos } = response;

		if ( mergedVideos?.length > 0 ) {
			const formattedMergedVideos = getFormattedData ( mergedVideos );

			return formattedMergedVideos;
		} else {
			return mergedVideos;
		}
	}
	if ( key === "videos" || key === "liveStreams" ) {
		const formattedData = getFormattedData ( response );

		return formattedData;
	}

	if ( key === "reels" ) {
		const formatedReels = response.map ( formatReel );

		return formatedReels;
	}

	return response;

};

const getTopCreatorVideoList = ( { broadcast, feed }, setTopVideos ) => {
	const data = [ ...broadcast, ...feed ];

	return setTopVideos ( data );
};

const handleBtn = () => {
	const id = document.getElementById ( "input-popover-target" );

	if ( id ) {
		id?.focus ();
	}
};

const component = props => {

	const { activeTab, searchQuery, changeTab, initialData } = props;

	if ( !initialData )
		return (
			<ErrorPage
				enableButton
				btnHandler = { handleBtn }
				btnText    = "Search Again"
				customMsg  = "No Matching Results Found"
				subHeading = "Try searching different keywords"
			/>
		);

	const { formattedMergedVideos, topCreator, formatedReels } = initialData;
	const [ topVideos, setTopVideos ]                          = useState ( [] );

	useEffect ( () => {
		if ( !topCreator || Object.keys ( topCreator ).length === 0 ) return;
		getTopCreatorVideoList ( { broadcast: topCreator?.broadcast, feed: topCreator?.feed }, setTopVideos );
	}, [ topCreator ] );

	// SWR API CALL
	const { data, error, size, setSize } = useSWRInfinite (
		index => {
			return { key: activeTab, pageNo: index + 1, searchQuery: searchQuery };
		},
		getResults,
		{ fallbackData: activeTab === "all" ? formattedMergedVideos : initialData }
	);

	// function to call API for next data in infinite call
	const getNextData = () => {
		setSize ( size + 1 );
	};

	// state for infinite call logic
	let __data                 = [].concat.apply ( [], data );
	const isLoadingInitialData = !data && !error;
	const isEmpty              = data?.[size - 1]?.length === 0;
	const isLoadingMore        = isLoadingInitialData || ( size > 0 && data && typeof data[size - 1] === "undefined" );

	return (
		<Presentation
			{ ...props }
			changeTab             = { changeTab }
			data                  = { __data }
			getNextData           = { getNextData }
			isDataDepleted        = { isEmpty }
			isFetchingData        = { isLoadingMore }
			loader                = { isLoadingInitialData }
			reels                 = { formatedReels }
			searchQuery           = { searchQuery }
			topCreator            = { topCreator }
			topVideos             = { topVideos }
		/>
	);
};

export default memo ( component );
